export default __webpack_public_path__ + "static/media/GothamSSm-Light.87c10aa2.svg";